import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter, Route, Switch } from 'react-router-dom'
import { createBrowserHistory } from 'history';

// Containers
import Full from './containers/Full/'
import Login from './views/Login/login'
import Register from './views/register/main'
import Firebase from 'firebase';
import Trial from './views/trial/trial'


const history = createBrowserHistory();

var produx = {
  apiKey: "AIzaSyANYvWuAeGYm78Q2hKqJsxGhnnHrFYczos",
  authDomain: "operatio-a399c.firebaseapp.com",
  databaseURL: "https://operatio-a399c.firebaseio.com",
  storageBucket: "operatio-a399c.appspot.com",
  messagingSenderId: "536442173780"
};

var develop = {
  apiKey: "AIzaSyBUBm9Ccl_mancuvJ34gKRjCJT9hdtg384",
  authDomain: "operatio-pro-dev-493b8.firebaseapp.com",
  databaseURL: "https://operatio-pro-dev-493b8.firebaseio.com",
  projectId: "operatio-pro-dev-493b8",
  storageBucket: "operatio-pro-dev-493b8.appspot.com",
  messagingSenderId: "261227604930"
};


Firebase.initializeApp(produx);


ReactDOM.render((
  <HashRouter history={history}>
    <Switch>
      <Route exact path="/trial" name="trial" component={Trial} />
      <Route exact path="/login" name="Login" component={Login} />
      <Route exact path="/register" name="Registro" component={Register} />
      <Route path="/" name="Home" component={Full} />
    </Switch>
  </HashRouter>
), document.getElementById('root'))



// WEBPACK FOOTER //
// ./src/index.js